import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import InsideLayout from "./layouts/InsideLayout"
//import OutsideLayout from "./layouts/OutsideLayout"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ru-RU'
import { library } from '@fortawesome/fontawesome-svg-core'
import { 
	faUserSecret, 
	faAngleDown, 
	faAngleUp, 
	faUsers, 
	faUserGear, 
	faBook, 
	faLaptopFile, 
	faFileCircleQuestion,
	faCubes,
	faTrowelBricks,
	faUserCheck,
	faDatabase,
	faBars,
	faSave,
	faTrashCan,
	faUserGraduate,
	faUser,
	faSquareCheck,
	faAlignLeft,
	faImage,
	faPanorama,
	faFilm,
	faCube,
	faArrowUp,
	faListUl,
	faMinimize,
	faMaximize,
	faExpand,
	faFileWord,
	faParagraph,
	faTv,
	faClapperboard,
	faPenToSquare,
	faPhotoFilm,
	faSquare,
	faPlus,
	faLink,
	faRightFromBracket,
	faLightbulb,
	faDisplay,
	faArrowRight,
	faAngleLeft,
	faAngleRight,
	faXmark,
	faHammer,
	faCircleQuestion,
	faQuestionCircle,
	faSpinner,
	faFilePdf,
	faDownload,
	faFileDownload,
	faUsersCog,
	faSpellCheck,
	faCheckDouble,
	faCalculator,
	faBriefcase,
	faEnvelopesBulk,
	faBell,
	faQuestion,
	faFile,
	faCircleNodes,
	faSquarePlus,
	faArrowDown,
	faUserPlus,
	faArrowRightFromBracket
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
	Pagination,
	Dialog,
	Autocomplete,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Menu,
	Submenu,
	MenuItem,
	MenuItemGroup,
	Input,
	InputNumber,
	Radio,
	RadioGroup,
	RadioButton,
	Checkbox,
	CheckboxButton,
	CheckboxGroup,
	Switch,
	Select,
	Option,
	OptionGroup,
	Button,
	ButtonGroup,
	Table,
	TableColumn,
	DatePicker,
	TimeSelect,
	TimePicker,
	Popover,
	Tooltip,
	Breadcrumb,
	BreadcrumbItem,
	Form,
	FormItem,
	Tabs,
	TabPane,
	Tag,
	Tree,
	Alert,
	Slider,
	Icon,
	Row,
	Col,
	Upload,
	Progress,
	Spinner,
	Badge,
	Card,
	Rate,
	Steps,
	Step,
	Carousel,
	CarouselItem,
	Collapse,
	CollapseItem,
	Cascader,
	ColorPicker,
	Transfer,
	Container,
	Header,
	Aside,
	Main,
	Footer,
	Timeline,
	TimelineItem,
	Link,
	Divider,
	Image,
	Calendar,
	Backtop,
	PageHeader,
	CascaderPanel,
	Loading,
	MessageBox,
	Message,
	Notification
} from 'element-ui';

Vue.use(ElementUI, { locale })
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Image);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(CascaderPanel);

Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

library.add(faUserSecret, faAngleDown, faAngleUp, faUsers, faUserGear, faBook, faLaptopFile, faFileCircleQuestion, faCubes, 
faTrowelBricks, faUserCheck, faDatabase, faBars, faSave, faTrashCan, faUserGraduate, faUser, faSquareCheck, faImage, faPanorama, 
faFilm, faCube, faAlignLeft, faArrowUp, faListUl, faMinimize, faMaximize, faExpand, faFileWord, faParagraph, faTv, faClapperboard,
faPenToSquare, faPhotoFilm, faSquare, faPlus, faLink, faRightFromBracket, faLightbulb, faDisplay, faArrowRight, faAngleLeft, 
faAngleRight, faXmark, faHammer, faCircleQuestion, faQuestionCircle, faSpinner, faFilePdf, faDownload, faFileDownload, faUsersCog, faSpellCheck, 
faCheckDouble, faCalculator, faBriefcase, faEnvelopesBulk, faBell, faQuestion, faFile, faCircleNodes, faSquarePlus, faArrowDown, faUserPlus, faArrowRightFromBracket)

Vue.prototype.$http = axios;
Vue.config.productionTip = false;
Vue.component("inside-layout", InsideLayout)
//Vue.component("outside-layout", OutsideLayout)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(CKEditor)

const token = localStorage.getItem('app_token')

if (token) {
	Vue.prototype.$http.defaults.headers.common['Authorization'] = "Bearer " + token
}

const debug = process.env.NODE_ENV !== 'production'
let system = 'logoright'
let title = 'ЛогоРайт'
let classname = 'ЛР'
let sourceUrl = ''
let timeout = 1000 * 60 * 90
let collapseSpeed = 1000

if (debug) {
    axios.defaults.baseURL = 'http://logoright.local/api'	
	sourceUrl = "http://logoright.local/api/upload/"
} else {				
	axios.defaults.baseURL = 'https://lk.logoright.ru/api'			
	sourceUrl = "https://lk.logoright.ru/api/upload/"	
}

localStorage.setItem('app_id', system)
localStorage.setItem('app_title', title)
localStorage.setItem('app_class_name', classname)
localStorage.setItem('app_source_url', sourceUrl)
localStorage.setItem('app_timeout', timeout)
localStorage.setItem('app_collapse_speed', collapseSpeed)

new Vue({
	router,
	render: h => h(App)
}).$mount('#app');